import React, { Component } from 'react';

import Page from '../../components/Page';

export default class Settings extends Component{

	render(){

		return(
			<Page isAdminPage={ true } pageTitle="Settings">
				<div className="row">
                    <div className="col-sm-6">
						<div className="panel panel-default">
							<div className="panel-heading">Basic Settings</div>
							<div className="panel-body">
								
							</div>
						</div>
					</div>
				</div>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/pages/user/Settings.jsx